import React from "react";
import "./PageToolbar.css";

interface PageToolbarProps {
  children: React.ReactNode;
  className?: string;
}

/** Groups filter + search controls with consistent spacing and alignment. */
const PageToolbar: React.FC<PageToolbarProps> = ({ children, className = "" }) => (
  <div className={`page-toolbar${className ? ` ${className}` : ""}`}>{children}</div>
);

export default PageToolbar;
